export default "__VITE_ASSET__7cf3706a__"